import LegacySpaceDetails from '../../../banking/components/spaces/LegacySpaceDetails';
import SpaceDetails from '../../../banking/components/spaces/SpaceDetails';
import {
    BankingExperience,
    useBankingExperience,
} from '../../../common/providers/BankingExperienceProvider';

const SavingsSpaceDetailsPage = () => {
    const { bankingExperience } = useBankingExperience();

    return bankingExperience === BankingExperience.CASH_CARD_ACCT ? (
        <SpaceDetails />
    ) : (
        <LegacySpaceDetails />
    );
};

export default SavingsSpaceDetailsPage;
